// extracted by mini-css-extract-plugin
export default {"content":"ImgBorder_content__wEk8U","img":"ImgBorder_img__p1nco"};